import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PortalPreviewData } from './portal-preview.model';

interface ItemExemplo {
  nome: string;
  sku: string;
  quantidade: string;
  unidade: string;
}

// Preview do formulário de cotação que o fornecedor recebe (portal/link).
// Renderiza com o branding e os campos habilitados na configuração atual;
// os itens são dados de exemplo.
@Component({
  selector: 'app-portal-cotacao-preview',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './portal-cotacao-preview.component.html',
  styleUrls: ['../../../../shared/styles/portal-preview-shared.css', './portal-cotacao-preview.component.css'],
})
export class PortalCotacaoPreviewComponent {
  public readonly itens: ItemExemplo[] = [
    { nome: 'Papel sulfite A4 75g', sku: 'PAP-A4-75', quantidade: '50', unidade: 'cx' },
    { nome: 'Toner HP 414A preto', sku: 'TON-414A-PT', quantidade: '8', unidade: 'un' },
    { nome: 'Cadeira de escritório ergonômica', sku: 'MOB-CAD-ERG', quantidade: '12', unidade: 'un' },
  ];

  constructor(
    public dialogRef: MatDialogRef<PortalCotacaoPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PortalPreviewData
  ) {}

  public isAtivo(chave: string): boolean {
    return this.data.camposAtivos.includes(chave);
  }

  public get heroGradient(): string {
    return `linear-gradient(135deg, ${this.data.corHeroInicio}, ${this.data.corHeroFim})`;
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
